import Grid from '@mui/material/Grid2';
import HubIcon from '@mui/icons-material/Hub';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import backgroundSection3 from "../../../../images/backgroundSection3.jpg";

const BENEFITS = [
  { Icon: HubIcon, label: "Registro estructurado y estandarizado" },
  { Icon: TaskAltIcon, label: "Validación automática de información" },
  { Icon: WorkspacePremiumIcon, label: "Certificados únicos con trazabilidad completa" },
  { Icon: ViewInArIcon, label: "Integración entre actores de la cadena" },
];

function SolutionSection() {
  return (
    <section
      className="bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: `linear-gradient(rgba(14,30,80,0.82),rgba(14,30,80,0.82)), url(${backgroundSection3})` }}
    >
      <div className="max-w-[1200px] mx-auto py-96 px-40 text-center">
        <h2 className="text-40 font-extrabold text-white mb-20 leading-[1.2]">
          Una plataforma única para registrar, validar y certificar materiales
        </h2>
        <p className="text-20 text-white/90 max-w-[780px] mx-auto mb-64 leading-[1.8]">
          EcoRep digitaliza y conecta a todos los actores de la cadena de economía circular para asegurar que cada material gestionado cuente con trazabilidad completa, validación confiable y certificación segura.
        </p>
        <Grid container spacing={3}>
          {BENEFITS.map(({ Icon, label }) => (
            <Grid key={label} size={{ xs: 12, sm: 6, md: 3 }}>
              <div className="bg-white/[0.08] border border-white/[0.18] rounded-[14px] py-40 px-24 h-full transition-colors duration-200 hover:bg-white/[0.14]">
                <Icon className="!text-40 text-[#38BDF8]" />
                <h3 className="text-18 font-semibold text-white mt-20 leading-[1.55]">{label}</h3>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
}

export default SolutionSection;
